function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2029 0.356445H15.6185C14.1233 0.356445 12.925 1.57597 12.925 3.07228V6.68739C12.925 8.19324 14.1233 9.40217 15.6185 9.40217H19.2029C20.6875 9.40217 21.8965 8.19324 21.8965 6.68739V3.07228C21.8965 1.57597 20.6875 0.356445 19.2029 0.356445ZM3.38107 0.356546H6.96542C8.46067 0.356546 9.65899 1.57607 9.65899 3.07238V6.68749C9.65899 8.19334 8.46067 9.40227 6.96542 9.40227H3.38107C1.89642 9.40227 0.6875 8.19334 0.6875 6.68749V3.07238C0.6875 1.57607 1.89642 0.356546 3.38107 0.356546ZM3.38107 12.5197H6.96542C8.46067 12.5197 9.65899 13.7297 9.65899 15.2355V18.8506C9.65899 20.3459 8.46067 21.5654 6.96542 21.5654H3.38107C1.89642 21.5654 0.6875 20.3459 0.6875 18.8506V15.2355C0.6875 13.7297 1.89642 12.5197 3.38107 12.5197ZM15.6185 12.5197H19.2029C20.6875 12.5197 21.8965 13.7297 21.8965 15.2355V18.8506C21.8965 20.3459 20.6875 21.5654 19.2029 21.5654H15.6185C14.1233 21.5654 12.925 20.3459 12.925 18.8506V15.2355C12.925 13.7297 14.1233 12.5197 15.6185 12.5197Z",
    style: {
      fill: "white"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.1a2fd2c0.svg";
export { ForwardRef as ReactComponent };